import * as cityApi from "src/api/city";

export function useCityFilter() {
  let cityFilter = ref({});
  let cities = ref([]);
  let citiesLoading = ref(false);

  let apiCallInProgress = false;

  const { states } = useStateFilter();

  const initCityFilter = async (state_cd) => {
    try {
      if (!apiCallInProgress) {
        const stateId = unref(states).find(
          (state) => state.state_code === state_cd,
        )?.id;

        if (!stateId) {
          return;
        }

        apiCallInProgress = true;

        citiesLoading.value = true;

        let response = await cityApi.index({
          stateId,
        });

        response = response?.data?.data;

        if (Array.isArray(response[0])) {
          cities.value = response.reduce((acc, city) => {
            acc = [...acc, ...city];

            return acc;
          }, []);
        } else {
          cities.value = response;
        }

        cityFilter.value = useFilter({
          entities: cities,
          entity: "city",
        });

        citiesLoading.value = false;

        apiCallInProgress = false;
      }
    } catch (error) {
      console.error(error);

      apiCallInProgress = false;
    }
  };

  return {
    cities,
    cityFilter,
    citiesLoading,
    initCityFilter,
  };
}
